<!--用户配置页面-->
<template>
  <treeBody>
    <!--左边-->
    <unitTree isShowUserNum="true" @checkItem='nowUnit = $event' slot="tree"></unitTree>
    <!--右边-->
    <div class="monreportRigth" slot="body">
      <div class="rigth">
        <div class="buttonLine">
          <iconButton @buttonClick='addUser' buttonText='添加' icoName="wedoButton/add.png"></iconButton>
          <iconButton @buttonClick='deleteUser' buttonText='删除' icoName="wedoButton/delete.png"></iconButton>
          <iconButton @buttonClick='editUser' buttonText='编辑' icoName="wedoButton/edit.png"></iconButton>
        </div>
        <infoList ref="infoList" @checkItem="nowUser = $event" style="height: calc(100% - 50px);" :columns='columns'
          :dataList="userList" pageLen='20' :fillAll="true" :totalSize="userList.length"></infoList>
      </div>
    </div>
  </treeBody>
</template>

<script type="text/javascript">
  import unitTree from '@/components/module/tree/unitTree.vue'
  import iconButton from '@/components/module/universal/iconButton.vue'
  import treeBody from '@/components/module/slotModule/treeBody.vue'
  import infoList from '@/components/module/universal/infoList.vue'
  //窗口
  import nomalInputDialog from '@/components/module/dialog/nomalInputDialog.vue'

  export default {
    components: {
      infoList,
      treeBody,
      unitTree,
      iconButton,
    },
    props: [],
    data () {
      return {
        nowUnit: undefined, //当前选中单位
        nowUser: undefined, //当前选中用户
        userList: [], //当前选中单位用户列表
        columns: [{
          name: "登录名",
          key: "usercode"
        },{
          name: "姓名",
          key: "username"
        },{
          name: "手机号",
          key: "mobile"
        },{
          name: "座机号",
          key: "telephone",
        },{
          name: "邮箱地址",
          key: "emailaddress"
        },{
          name: "邮箱密码",
          key: "emailpsw"
        }]
      }
    },
    created () {
      debugPage=this
    },
    mounted () {},
    destroyed () {},
    computed: {},
    watch: {
      nowUnit (nv,ov) {
        if(!isempty(nv)) {
          this.findUserByUnitId()
        }
      }
    },
    methods: {
      findUserByUnitId () {
        this.$api.userApi.findUserByUnitId(this.nowUnit.id,respon => {
          this.userList=respon
        })
      },
      //添加
      addUser () {
        if(this.nowUnit==undefined) {
          this.$dialogMethod.showMessage("请先选择单位!")
          return
        }
        var unitId=this.nowUnit.id //当前选中单位树的id
        var dialog=this.$dialogMethod.createDialog(nomalInputDialog)
        dialog.open('添加用户',[{
          name: '登陆名',
          pkid: 'usercode',
        },{
          name: '用户名称',
          pkid: 'username',
        },{
          name: '密码',
          pkid: 'password',
        },{
          name: '确认密码',
          pkid: 'password1',
        },{
          name: '手机号',
          pkid: 'mobile',
        },{
          name: '座机号',
          pkid: 'telephone',
        },{
          name: '邮箱地址',
          pkid: 'emailaddress',
        },{
          name: '邮箱密码',
          pkid: 'emailpsw',
        }],item => {
          if(isempty(item.usercode)) {
            this.$dialogMethod.showMessage("请输入登录名！")
            return false;
          }
          if(isempty(item.username)) {
            this.$dialogMethod.showMessage("请输入用户名称！")
            return false;
          }
          if(isempty(item.password)) {
            this.$dialogMethod.showMessage("请输入密码！")
            return false;
          }
          if(item.password!=item.password1) {
            this.$dialogMethod.showMessage("两次密码不一致！")
            return false;
          }
          //添加接口
          this.$api.userApi.saveUser("",item.username,item.usercode,hex_md5(item.password),
            item.mobile,item.telephone,unitId,item.emailaddress,item.emailpsw,undefined,undefined,undefined,undefined,undefined,undefined,respon => {
              this.$dialogMethod.showMessage("添加成功!")
              //刷新页面
              this.findUserByUnitId()
            },respon => {
              err(respon)
            })
        })
      },
      //修改
      editUser () {
        if(this.nowUser==undefined) {
          this.$dialogMethod.showMessage("请先选中要编辑的用户!")
          return
        }
        var dialog=this.$dialogMethod.createDialog(nomalInputDialog)
        dialog.open('修改单位',[{
          name: '登陆名',
          pkid: 'usercode',
          disabled: 'disabled',
          defaultValue: this.nowUser.usercode
        },{
          name: '用户名称',
          pkid: 'username',
          defaultValue: this.nowUser.username
        },{
          name: '密码',
          pkid: 'password',
        },{
          name: '确认密码',
          pkid: 'password1',
        },{
          name: '手机号',
          pkid: 'mobile',
          defaultValue: this.nowUser.mobile
        },{
          name: '座机号',
          pkid: 'telephone',
          defaultValue: this.nowUser.telephone
        },{
          name: '邮箱地址',
          pkid: 'emailaddress',
          defaultValue: this.nowUser.emailaddress
        },{
          name: '邮箱密码',
          pkid: 'emailpsw',
        }],item => {
          if(isempty(item.username)) {
            this.$dialogMethod.showMessage("请输入用户名称！")
            return false;
          }
          if(isempty(item.password)) {
            this.$dialogMethod.showMessage("请输入密码！")
            return false;
          }
          if(item.password!=item.password1) {
            this.$dialogMethod.showMessage("两次密码不一致！")
            return false;
          }
          this.$api.userApi.saveUser(this.nowUser.id,item.username,item.usercode,hex_md5(item.password),
            item.mobile,item.telephone,this.nowUser.entityid,item.emailaddress,
            item.emailpsw,'','',this.nowUser.reportDir,respon => {
              this.$dialogMethod.showMessage("修改成功!")
              //刷新页面
              this.findUserByUnitId()
            },respon => {
              err(respon)
            })
        })
      },
      //删除
      deleteUser () {
        if(this.nowUser==undefined) {
          this.$dialogMethod.showMessage("请先选中要删除的用户!")
          return
        }
        this.$dialogMethod.openAgreeDialog("删除用户","是否删除 "+this.nowUser.username,() => {
          //删除接口
          this.$api.userApi.deleteUserById(this.nowUser.id,respon => {
            //刷新
            this.findUserByUnitId()
            this.$dialogMethod.showMessage(respon)
            this.nowUnit=undefined
          },respon => {
            err(respon)
          })
        })
      },

    }
  }
</script>

<style scoped>
  .rigth {
    float: left;
    height: 100%;
    width: 100%;
  }

  .monreportRigth {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .entityTree {
    float: left;
    width: 2rem;
  }
</style>